import React from 'react';
import Link from 'next/link';
import { ProductDiscountWithImage } from '@services';
import { ROUTES } from '@constants';
import styles from './DiscountInfo.module.scss';
import classnames from 'classnames/bind';

const CN = 'discount-card';
const imageClassName = `${CN}--image`;

const cx = classnames.bind(styles);

interface Props {
  discount: ProductDiscountWithImage
}

export const DiscountCard: React.FC<Props> = ({ discount }) => (
  <div className={ cx(CN) }>
    <Link href={ `${ROUTES.discountedProducts}/${discount.id}` }>
      <img className={ cx(imageClassName) } src={ discount.image }/>
    </Link>
  </div>
);
